import { render, staticRenderFns } from "./classRecord.vue?vue&type=template&id=3f0d8410&scoped=true"
import script from "./classRecord.vue?vue&type=script&lang=js"
export * from "./classRecord.vue?vue&type=script&lang=js"
import style0 from "./classRecord.vue?vue&type=style&index=0&id=3f0d8410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0d8410",
  null
  
)

export default component.exports